import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Button,
    Stack
} from "@mui/material";
import { colours } from "../../StyleConstants";

interface ManuscriptPrepubReviewDialogProps {
    open: boolean;
    onAnswer: (submitted: boolean) => void;
}

const ManuscriptPrepubReviewDialog: React.FC<ManuscriptPrepubReviewDialogProps> = ({
    open,
    onAnswer,
}) => {
    return (
        <Dialog
            open={open}
            disableEscapeKeyDown
            maxWidth="sm"
            fullWidth
            BackdropProps={{
                sx: {
                    backdropFilter: "blur(6px)",
                    backgroundColor: "rgba(0, 0, 0, 0.2)",
                },
            }}
        >
            <DialogTitle variant="h5" fontWeight="600" color={colours.midnightBlue.blue}>
                Pre-Publication Review
            </DialogTitle>

            <DialogContent dividers>
                <Typography variant="body1">
                    Did you submit manuscripts analyzing AI/AN data for pre-publication review
                    to nbdc@mail.nih.gov?
                </Typography>
            </DialogContent>
            <DialogActions
                sx={{
                    p: 3,
                    display: "flex",
                    justifyContent: "center",
                }}
            >
                <Stack direction="row" spacing={2}>
                    <Button variant="primary" onClick={() => onAnswer(true)}>
                        Yes
                    </Button>
                    <Button variant="secondary" onClick={() => onAnswer(false)}>
                        No
                    </Button>
                </Stack>
            </DialogActions>
        </Dialog>
    );
};

export default ManuscriptPrepubReviewDialog;
